import { Link, useRouter } from "@tanstack/react-router";
import type { PropsWithChildren } from "react";
import { Button } from "../shad/button";
import { IconArrowBack, IconPlus } from "@tabler/icons-react";
import { cn } from "@/client/lib/utils";
import { SidebarTrigger } from "../shad/sidebar";
import { Separator } from "../shad/separator";

export const Layout = ({ children }: PropsWithChildren) => {
  return <div className="pb-6 relative">{children}</div>;
};

export const LayoutContent = ({ children }: PropsWithChildren) => {
  return (
    <div className="p-6 pt-9 w-full mx-auto max-w-5xl grid lg:grid-cols-7 gap-24 relative">
      {children}
    </div>
  );
};

export const LayoutBody = ({ children }: PropsWithChildren) => {
  return <div className="lg:col-span-4 relative min-w-md">{children}</div>;
};

export const LayoutBodyHeader = () => {
  const router = useRouter();
  return (
    <header className="mb-10">
      <Button
        onClick={() => router.history.back()}
        type="button"
        variant="secondary"
        size="sm"
      >
        <IconArrowBack />
        Back
      </Button>
    </header>
  );
};

export const LayoutAside = ({
  children,
  first = false,
}: PropsWithChildren & { first?: boolean }) => {
  return (
    <aside
      className={cn(
        "lg:col-span-3 relative",
        first && "order-first lg:order-0",
      )}
    >
      <div className="w-full sticky top-22">{children}</div>
    </aside>
  );
};

export const LayoutHeader = ({ children }: PropsWithChildren) => {
  return (
    <header className="sticky top-0 z-10 backdrop-blur-sm border-b flex mt-px h-13 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12">
      <div className="flex grow items-center gap-2 px-4">
        <SidebarTrigger className="-ml-1" />
        <Separator
          orientation="vertical"
          className="mr-2 data-[orientation=vertical]:h-4"
        />
        {children}
      </div>
      <div className="px-4 flex gap-4">{/*Placeholder*/}</div>
    </header>
  );
};
